// eslint-disable-next-line no-restricted-imports
import { name, version } from '../package.json';
import App from '@/App.vue';
import i18n from '@/translations/i18n';
import initStore from '@/utils/initStore';
import iFrameApi from '@/api';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import '@/utils/polyfill';
import '@/assets/style/main.css';
import * as Sentry from '@sentry/vue';

const app = createApp(App);

Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    trackComponents: true,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: true,
            blockAllMedia: true,
        }),
        Sentry.replayCanvasIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: [/^https:\/\/api.next.myclient.fr/, /^https:\/\/api.app.myclient.fr/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // Capture 10% of the sessions
    replaysOnErrorSampleRate: 1.0, // Capture 100% of the errors
});

app.use(createPinia());
app.use(i18n);
initStore();
app.mount('#app');

// Tells the integration that the app is ready
iFrameApi.ready();

console.info(`${name} - v${version}`);
